import React, { useState, useEffect } from "react"
import { Link } from "gatsby"

const Header = props => {
  const [toggleMenu, setToggleMenu] = useState(true)
  const [menuClass, setMenuClass] = useState("")

  const toggleMenuHandler = () => {
    if (window.innerWidth < 1000) {
      if (menuClass === "") {
        setToggleMenu(!toggleMenu)
        props.toggleBackdrop()
        setTimeout(() => {
          setMenuClass("menuActive")
        }, 1)
      } else {
        setMenuClass("")
        props.toggleBackdrop()
        setTimeout(() => {
          setToggleMenu(!toggleMenu)
        }, 400)
      }
    }
  }

  const [isMoving, setIsMoving] = useState(false)

  const handleScroll = () => {
    const scroll = window.scrollY > 20
    if (scroll) {
      setIsMoving(true)
    } else {
      setIsMoving(false)
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
  }, [])

  return (
    <>
      <header className={`${menuClass} ${isMoving ? "menuMoving" : ""}`}>
        <div className='logoWrapper'>
          <Link to='/'>
            <img className='logo' src='/logo.png' alt='Onur Tesisat Logo' />
          </Link>
        </div>
        <div
          className='headerWrapper'
          onClick={toggleMenuHandler}
          role='button'
          tabIndex={-1}
        >
          <div className={`menu`}>
            <div className='menuTop'>
              <a className='menuTopElement' href='tel:905550175093'>
                <div className='menuTopIcon'>
                  <img src='/phone-icon.png' alt='Onur Tesisat Telefon' />
                </div>
                <div className='menuText'>
                  7/24 Çağrı Merkezi <br />
                  +90 555 017 50 93
                </div>
              </a>
              <a className='menuTopElement' href='mailto:info@onurtesisat.com'>
                <div className='menuTopIcon'>
                  <img src='/mail-icon.png' alt='Onur Tesisat Mail' />
                </div>
                <div className='menuText'>
                  Bize Mail Yolla <br />
                  info@onurtesisat.com
                </div>
              </a>
              <Link
                to='https://wa.me/905550175093?text=Merhaba'
                target='_blank'
                rel='noopener noreferrer'
                className='button hide'
              >
                SERVİS TALEP
              </Link>
            </div>
            <div className='dHide' style={{ margin: "15px 0" }}>
              <Link
                to='https://wa.me/905550175093?text=Merhaba'
                target='_blank'
                rel='noopener noreferrer'
                className='button'
              >
                SERVİS TALEP
              </Link>
            </div>
            <div className='menuBottom'>
              <Link className='menuBottomElement' to='/'>
                <div className='menuIcon'>
                  <img src='/home-icon.svg' alt='Onur Tesisat Anasayfa' />
                </div>
                <div className='menuText'>Anasayfa</div>
              </Link>
              <Link className='menuBottomElement' to='/hizmetler'>
                <div className='menuIcon'>
                  <img src='/wrench-icon.png' alt='Onur Tesisat Hizmetler' />
                </div>
                <div className='menuText'>Hizmetler</div>
              </Link>
              <Link className='menuBottomElement' to='/iletisim'>
                <div className='menuIcon'>
                  <img src='/contact-icon.png' alt='Onur Tesisat İletişim' />
                </div>
                <div className='menuText'>İletişim</div>
              </Link>
            </div>
          </div>
        </div>
      </header>
      <div className='mBar'>
        <Link to='/'>
          <img className='logo' src='/logo.png' alt='Onur Tesisat Logo' />
        </Link>
        <div
          className={`mMenuButton ${
            menuClass === "menuActive" ? "active" : ""
          }`}
          onClick={toggleMenuHandler}
          //onKeyDown={toggleMenuHandler}
          role='button'
          tabIndex={-1}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </>
  )
}

export default Header
